export const TabName = (document) => {
  const { document_source_details , updated_at } = document;
  
  const tab_name = document_source_details? document_source_details?.split('@')[0] + "_" + updated_at.split(" ")[0].split("-")[2] :"Unknown";
  return tab_name

};